import { checkSeverUptime } from 'functions/api/serverStatus';
import { clearAuthDataInLocalStorage } from 'functions/clearAuthDataInLocalStorage';
import serverStatusConstants from '../constants/serverStatus';

const checkServerStatus = () => async (dispatch) => {
  dispatch({ type: serverStatusConstants.SERVER_STATUS_REQUEST });

  try {
    await checkSeverUptime();

    dispatch({ type: serverStatusConstants.SERVER_STATUS_SUCCESS });
  } catch (error) {
    console.error("Error checking the server's status", error);

    if (error.response?.status && [401, 419].includes(error.response.status)) {
      clearAuthDataInLocalStorage();
    }

    dispatch({
      type: serverStatusConstants.SERVER_STATUS_FAILURE,
      payload: {
        error: error.message,
      },
    });
  }
};

export const serverStatusActions = {
  checkServerStatus,
};
